import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendService } from './backend.service';
import { OrganizationDto } from '../dto/organization.dto';
import {
  ProcessResult,
  QueryOptions,
  QueryResult,
} from '../components/common-dto/query.dto';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  constructor(private backend: BackendService) {}

  getOrganizations(
    queryParams: QueryOptions
  ): Observable<QueryResult<OrganizationDto>> {
    return this.backend.getQuery<OrganizationDto>('organization', queryParams);
  }

  getOrganization(id: string): Observable<OrganizationDto> {
    return this.backend.get<OrganizationDto>(`organization/${id}`);
  }

  createOrganization(
    organization: OrganizationDto
  ): Observable<ProcessResult> {
    organization.createdAt = undefined;
    organization.updatedAt = undefined;
    return this.backend.post<ProcessResult>('organization', organization);
  }

  updateOrganization(
    id: string,
    organization: OrganizationDto
  ): Observable<ProcessResult> {
    return this.backend.put<ProcessResult>(`organization/${id}`, organization);
  }

  deleteOrganization(id: string): Observable<ProcessResult> {
    return this.backend.delete<ProcessResult>(`organization/${id}`);
  }
}

